/**
 * After a deploy, a tab still running the previous build can request hashed
 * chunks that no longer exist. A single full reload picks up the new build;
 * the timestamp guard stops a genuinely broken chunk from reloading forever.
 */
const LAST_RELOAD_KEY = "wa:staleBuildReloadAt";
const MIN_MS_BETWEEN_RELOADS = 10_000;

const STALE_ASSET_MESSAGE =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|is not a valid JavaScript MIME type|Unable to preload CSS/i;

let reloadInProgress = false;

export const isStaleAssetError = (error: unknown): boolean => {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";
  return STALE_ASSET_MESSAGE.test(message);
};

/** Returns true when a reload has been started (or already was). */
export const reloadForStaleBuild = (): boolean => {
  if (reloadInProgress) {
    return true;
  }
  try {
    const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
    if (lastReloadAt && Date.now() - lastReloadAt < MIN_MS_BETWEEN_RELOADS) {
      return false;
    }
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  } catch {
    return false;
  }
  reloadInProgress = true;
  window.location.reload();
  return true;
};
